import { useATTrackInteraction } from '@at/consumer-web-snowplow'

export const useTrackingHandlers = (): {
    trackOpenSearchModal: ReturnType<typeof useATTrackInteraction>
    trackSearchFilterReset: ReturnType<typeof useATTrackInteraction>
} => {
    const trackOpenSearchModal = useATTrackInteraction({
        trackingLabel: 'search-filter-modal-open',
    })

    const trackSearchFilterReset = useATTrackInteraction({
        trackingLabel: 'search-filter-reset',
    })

    return {
        trackOpenSearchModal,
        trackSearchFilterReset,
    }
}
